<template>
  <van-overlay :show="visible" :lock-scroll="false">
    <div class="popup" @click.stop>
      <div class="main-bg">
        <div class="content-bg">
          <!-- :style="
              'background-image: url(' +
              backgroundImg +
              ');background-repeat: no-repeat;background-size: 100% 100%;'
            " -->
          <div
            class="contain-box"
            :style="
              'background-image: url(' +
              backgroundImg +
              ');background-repeat: no-repeat;background-size: 100% 100%;'
            ">
            <div class="title">
              {{ title || "7周年活动详情" }}
            </div>
            <div class="content-box">
              <div class="content" v-html="htmlText"></div>
            </div>
            <div class="sure-bg" @click="clickSure">确认</div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
  
  <script>
import { Icon, Overlay } from "vant"
export default {
  name: "anniversaryPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    backgroundImg: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    amount: {
      type: Number,
      default: 0
    },
    currentAnnual: {
      type: Number,
      default: 0
    },
    totalAnnual: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      htmlText: ""
    }
  },
  mounted() {
    this.htmlText =
      "尊敬的" +
      this.userInfo.name +
      "投资人：</br>您本次认购金额" +
      this.numFormat(this.amount) +
      "元</br>本次认购年化金额" +
      this.numFormat(this.currentAnnual) +
      "元</br>七周年活动期间累计年化认购" +
      this.numFormat(this.totalAnnual) +
      "元</br>感谢您对天安金交中心一直以来的支持！"
  },
  methods: {
    clickSure() {
      this.$emit("update:visible", false)
      this.$emit("onSureClick")
    }
  }
}
</script>
  
  <style lang="less" scoped>
.van-overlay {
  z-index: 100;
}
.popup {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .main-bg {
    width: calc(100% - 20px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    .content-bg {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .contain-box {
        background-image: url("../../assets/img/my-redpack/anniversary/anniversary_pop_bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: center;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title {
          text-align: center;
          margin: 160px 20px 0 30px;
          color: rgb(251, 244, 225);
          font-size: 22px;
          font-weight: 900;
          text-shadow: 2px 2px 5px rgb(189, 150, 136);
        }
        .content-box {
          margin: 20px 30px 0 30px;
          border: 3px solid rgb(199, 144, 54);
          border-radius: 20px;
          background-color: white;
          .content {
            line-height: 30px;
            text-align: left;
            color: rgb(149, 148, 146);
            font-size: 16px;
            font-weight: 900;
            padding: 20px;
          }
        }
        .sure-bg {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 50px;
          margin: 20px 30px 15px 30px;
          border-radius: 25px;
          background-color: white;
          text-align: center;
          color: rgb(215, 173, 102);
          font-size: 25px;
          -moz-box-shadow: 2px 2px 5px rgb(155, 155, 155);
          -webkit-box-shadow: 2px 2px 5px rgb(155, 155, 155);
          box-shadow: 2px 2px 10px rgb(155, 155, 155);
        }
      }
    }
  }
}
</style>